import ResearcherDashboardService, { getOrganisations, getCorrespondentsStatus }
 from './ResearcherDashboardService';

export default { ResearcherDashboardService, getOrganisations, getCorrespondentsStatus }